import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'flag-icons/css/flag-icons.min.css';
import schedule from "../data/schedule.json";

export default function SpeakersCarousel() {
  const speakers = schedule.flatMap((block) => block.speakers);
  
  return (
    <section className="speakers">
      <div className="container">
        <h2 className="title">Nuestros Ponentes</h2>
        <Swiper
          modules={[Pagination, Autoplay]}
          loop={true}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={3}
          spaceBetween={40}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          //   pagination={{
          //     clickable: true,
          //   }}
          breakpoints={{
            0: { slidesPerView: 1, centeredSlides: true },
            480: { slidesPerView: 1, centeredSlides: true },
            768: { slidesPerView: 1, centeredSlides: true },
            1024: { slidesPerView: 5, centeredSlides: true },
          }}
          className="slider-wrapper">
          {speakers.map((spk, i) => (
            <SwiperSlide key={i} className="speaker-slide">
              <div className="card-item">
                <div className="speaker-img">
                  <img src={spk.image} alt={spk.name} />
                  <span className={`fi fi-${spk.flag} flag-overlay`}></span>
                </div>
                <h3 className="user-name">{spk.name}</h3>
                <p className="user-profession">{spk.role}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
